import {DropdownWithTags, TabsComponent} from '@/components/molecules'
import {useGetCategoryDropdown} from '@/hooks/promotion/useGetCategoryDropdown'
import {useCategoryList} from '@/hooks/useCategoryList'
import {useSubCategoryList} from '@/hooks/useSubCategoryList'
import {SELECTION_TYPE} from '@/utils/constants/commonConstants'
import {useMemo} from 'react'

/**
 * CategoryAndSubCategoryContent - Handles Category ↔︎ Sub-category selection within the Promotion Selection modal.
 * Behaviour is aligned to ProductAndBrandContent – the dropdown only shows the tags that belong to the
 * currently active tab, while preserving previously chosen values when the user switches between tabs.
 */
const CategoryAndSubCategoryContent = ({
  activeTabIndex,
  selectedTags,
  combination,
  tabs = [],
  onTabChange = () => {},
  setSelectedTags = () => {},
  setCombination = () => {},
  isExclude = false,
}) => {
  // Current active tab object
  const activeTab = tabs[activeTabIndex]

  // Determine dropdown type – prefer explicit value from config; fallback based on id
  const dropdownType =
    activeTab?.dropDownType ||
    (activeTab?.id === 'CATEGORY' ? 'categories' : activeTab?.id === 'SUBCATEGORY' ? 'sub_categories' : '')

  // Resolve the actual API endpoint name (similar to ProductAndBrandContent)
  const resolvedDropdownType = dropdownType === 'categories' ? 'display_categories' : dropdownType

  // Hooks for fetching data (enabled conditionally)
  const {categoryListData, isLoading: isLoadingCategories} = useCategoryList(
    resolvedDropdownType,
    dropdownType === 'categories'
  )
  const {subCategoryListData, isLoading: isLoadingSubCategories} = useSubCategoryList(dropdownType === 'sub_categories')

  // Fallback generic dropdown values (enabled only if not category/sub_category)
  const {data: genericData, isLoading: isLoadingGeneric} = useGetCategoryDropdown(
    dropdownType === 'categories' || dropdownType === 'sub_categories' ? '' : dropdownType
  )

  const childList = useMemo(() => {
    if (dropdownType === 'categories') {
      return categoryListData.map(item => ({
        id: item.id,
        displayText: item.en,
      }))
    }
    if (dropdownType === 'sub_categories') {
      return subCategoryListData.map(item => ({
        id: item.id,
        displayText: item.en,
      }))
    }
    return (
      genericData?.data?.map(item => ({
        id: item?.id ?? item,
        displayText: item?.en ?? item,
      })) || []
    )
  }, [dropdownType, categoryListData, subCategoryListData, genericData])

  const isLoading =
    dropdownType === 'categories'
      ? isLoadingCategories
      : dropdownType === 'sub_categories'
        ? isLoadingSubCategories
        : isLoadingGeneric

  // Only display tags that belong to the active tab
  const selectedOptions = selectedTags.itemType === activeTab?.id ? selectedTags.values : []

  return (
    <>
      <TabsComponent
        tabList={tabs}
        defaultTabIndex={activeTabIndex}
        onTabChange={onTabChange}
        className={'text-[#EFEFEF]'}
      />
      <div>
        <DropdownWithTags
          childList={childList}
          onChange={value => {
            setSelectedTags({itemType: activeTab?.id || '', values: value})
          }}
          placeholder={selectedOptions.length > 0 ? 'Selected' : activeTab?.tabLabel}
          selectedOptions={selectedOptions}
          label={activeTab?.tabLabel}
          selection={isLoading ? SELECTION_TYPE.LOADING : SELECTION_TYPE.MULTIPLE}
          maxSelections={5}
        />
        {/* {!isExclude && (
          <Toggle
            isDark
            updateValue={value => {
              setCombination(value)
            }}
            value={combination}
            uiSchema={{size: 'small', label: 'Combination of Products'}}
          />
        )} */}
        <div className={`${!isExclude ? 'my-4' : ''} h-[1px] bg-[#4E4E4E]`} />
      </div>
    </>
  )
}

export default CategoryAndSubCategoryContent
